import React from "react";
import { useTranslation } from "react-i18next";

export const Placeholder = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t("testing.placeholder")}</h1>
    </div>
  );
};
